let API_KEY = "785929e86aa524cbb4256e03c42c731f";

export const getKey = () => {
	return API_KEY;
};
